<div>

  <h3>梁以德教授</h3>
  <h3>Prof Andrew YT Leung</h3>
  <p i18n="@@smartProfile_1">
    Prof Andrew YT Leung is the sole proprietor of Smart Integration Company.
  </p>
  <p i18n="@@smartProfile_2">
    He is an emeritus professor of City University of Hong Kong, and previously a professor of Manchester University and Hong Kong University.
    His research interests are wind and earthquake engineering, fatigue, fracture and corrosion, noise and vibration reduction, environmental acoustics, structure vibration, monitoring and control, dynamic stress, jet fan, and tunnelling.
  </p>
  <p i18n="@@smartProfile_3">
    His other positions held include: the President of the Asian Institute of Intelligent Buildings, China Green Building (HK) Council,
    Kowloon Central Rotary Club, Hon President of Kowloon Federation of Associations, Adviser of the Hong Kong Electrical and Mechanical College
    (which is a member of the Federation of Hong Kong and Kowloon Labour Unions), and the education adviser of the Hong Kong Alzheimer’s Association.
  </p>
  <p i18n="@@smartProfile_4">
    One of his current focus is in improving the quality of life of people, in all levels of society, through the use existing and emerging technology, by leveraging his experience in research, engineering, and organisation.
    Professor Leung founded Smart Integration Company to carry out these goals.
  </p>

  <hr>
  <h3 >Consultancy</h3>
  <app-consultancy></app-consultancy>

  <hr>
  <h3>Projects</h3>
  <app-project-ideas></app-project-ideas>
</div>
